// ------------------ React Components ------------------------
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CiImageOn, CiSearch } from "react-icons/ci";
import { LiaSpinnerSolid } from "react-icons/lia";
import { MdCancel, MdDeleteOutline } from "react-icons/md";
import { FaRegSave, FaClipboardList, FaSpinner } from 'react-icons/fa';
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';
import ItemAddedToaster from '../../toasterscomponents/checklistToasters/ItemAddedToaster';
import FilledInChecklistToaster from '../../toasterscomponents/FilledInChecklistToaster';
import CreatedSuccesFullyToaster from '../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';
import { IoIosCloudDone } from 'react-icons/io';
import ItemRemovedToaster from '../../toasterscomponents/checklistToasters/ItemRemovedToaster';

const ToasterConsultantFill = ({ 

  isOpen, 
  onClose, 
  selectedShePackName,
  shePackDocuments,
  isLoading,
  questionsPerDocument,

  selectedCompany,
  selectedDepartment,// Add this prop

  selectedCompanyName,
  selectedDepartmentName,

  onScoreUpdate

}) => {
  
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToaster, setShowToaster] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [answers, setAnswers] = useState({});

  const [totalUserScore, setTotalUserScore] = useState(0);
  const [totalUserPercentage, setTotalUserPercentage] = useState(0);
  const [shePackScore, setShePackScore] = useState(0)

  const [savedQuestions, setSavedQuestions] = useState({});

  const [savingQuestions, setSavingQuestions] = useState({});
  // Add state for category saving
const [savingCategories, setSavingCategories] = useState({});

 


  const [errorMessage, setErrorMessage] = useState('');
  const [questionErrors, setQuestionErrors] = useState({});
  const [questionCategoryErrors, setQuestionCategoryErrors] = useState({});
  const [expiryDateInput, setExpiryDateInput] = useState({});
  const [expandedDocuments, setExpandedDocuments] = useState({});

  const [files, setFiles] = useState({});
  // Add this state to your component's useState declarations
const [expandedImageIndex, setExpandedImageIndex] = useState(null);
// Add this state to track previous file responses
const [previousFileResponses, setPreviousFileResponses] = useState({});

const [removedPreviousFiles, setRemovedPreviousFiles] = useState({});
  const [comments, setComments] = useState({});
  
  const [questionScores, setQuestionScores] = useState({});

  const user = JSON.parse(sessionStorage.getItem('user'));

  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [previewPhotos, setPreviewPhotos] = useState({});
  const [isPreviewExpanded, setIsPreviewExpanded] = useState(false);

  // Search 
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredQuestionsPerDocument, setFilteredQuestionsPerDocument] = useState({});

  //
  // Alternative approach: Reset states when toaster closes
useEffect(() => {
  if (!isOpen) {
    // Clean up object URLs to prevent memory leaks
    Object.values(previewPhotos).forEach(url => {
      if (url && typeof url === 'string' && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
    if (previewPhoto && typeof previewPhoto === 'string' && previewPhoto.startsWith('blob:')) {
      URL.revokeObjectURL(previewPhoto);
    }
    
    // Reset all states when closing
    setIsExpanded(false);
    setShowToaster({});
    setShowSuccess(false);
    setSubmitStatus(null);
    setAnswers({});
    setTotalUserScore(0);
    setTotalUserPercentage(0);
    setShePackScore(0);
    setSavedQuestions({});
    setErrorMessage('');
    setQuestionErrors({});
    setQuestionCategoryErrors({});
    setExpiryDateInput({});
    setExpandedDocuments({});
    setFiles({});
    setExpandedImageIndex(null);
    setPreviousFileResponses({});
    setRemovedPreviousFiles({});
    setComments({});
    setQuestionScores({});
    setFullScreenImage(null);
    setPreviewPhoto(null);
    setPreviewPhotos({});
    setIsPreviewExpanded(false);
    setSearchTerm('');
    setFilteredQuestionsPerDocument({});

    // Reset saving states
    setSavingQuestions({});
    setSavingCategories({});
  }
}, [isOpen]);

  //
  useEffect(() => {
  if (!searchTerm.trim()) {
    setFilteredQuestionsPerDocument(questionsPerDocument);
    return;
  }

  const filtered = {};
  Object.entries(questionsPerDocument).forEach(([documentId, categories]) => {
    filtered[documentId] = {};
    
    Object.entries(categories).forEach(([category, categoryQuestions]) => {
      const filteredQuestions = categoryQuestions.filter(question => 
        question.question_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        question.question_reference?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      if (filteredQuestions.length > 0) {
        filtered[documentId][category] = filteredQuestions;
      }
    });
  });
  
  setFilteredQuestionsPerDocument(filtered);
}, [searchTerm, questionsPerDocument]);


  // Add this to the useEffect that calculates the scores
useEffect(() => {
  if (shePackDocuments && shePackDocuments.length > 0) {
    let userScoreSum = 0;
    let documentScoreSum = 0;
    
    shePackDocuments.forEach(doc => {
      // Add user score if it exists (convert to number to ensure proper addition)
      userScoreSum += doc.user_score ? Number(doc.user_score) : 0;
      
      // Use effective_document_score if available, otherwise use shepack_document_score
      const docScore = doc.effective_document_score ? Number(doc.effective_document_score) : 
                      (doc.shepack_document_score ? Number(doc.shepack_document_score) : 0);
      documentScoreSum += docScore;
    });
    
    setTotalUserScore(userScoreSum);
    setShePackScore(documentScoreSum); // Add this line to set the total shePackScore
    
    // Calculate percentage only if documentScoreSum is not zero to avoid division by zero
    if (documentScoreSum > 0) {
      const percentage = (userScoreSum / documentScoreSum) * 100;
      setTotalUserPercentage(percentage.toFixed(2)); // Round to 2 decimal places
    } else {
      setTotalUserPercentage(0);
    }
  }
}, [shePackDocuments]);

  // Calculate the total scores and percentages whenever the shePackDocuments changes
  useEffect(() => {
    if (shePackDocuments && shePackDocuments.length > 0) {
      let userScoreSum = 0;
      let documentScoreSum = 0;
      
      shePackDocuments.forEach(doc => {
        // Add user score if it exists (convert to number to ensure proper addition)
        userScoreSum += doc.user_score ? Number(doc.user_score) : 0;
        
        // Use effective_document_score if available, otherwise use shepack_document_score
        const docScore = doc.effective_document_score ? Number(doc.effective_document_score) : 
                        (doc.shepack_document_score ? Number(doc.shepack_document_score) : 0);
        documentScoreSum += docScore;
      });
      
      setTotalUserScore(userScoreSum);
      
      // Calculate percentage only if documentScoreSum is not zero to avoid division by zero
      if (documentScoreSum > 0) {
        const percentage = (userScoreSum / documentScoreSum) * 100;
        setTotalUserPercentage(percentage.toFixed(2)); // Round to 2 decimal places
      } else {
        setTotalUserPercentage(0);
      }
    }
  }, [shePackDocuments]);


  // Add clean-up for the URL objects when component unmounts
useEffect(() => {
  return () => {
    // Clean up all the created object URLs to prevent memory leaks
    Object.values(previewPhotos).forEach(url => {
      URL.revokeObjectURL(url);
    });
    if (previewPhoto) {
      URL.revokeObjectURL(previewPhoto);
    }
  };
}, [previewPhotos, previewPhoto]);



 
  useEffect(() => {
    // Initialize previous responses when questions are loaded
    if (questionsPerDocument) {
      Object.entries(questionsPerDocument).forEach(([documentId, categories]) => {
        Object.values(categories).forEach(questions => {
          questions.forEach(question => {
            // Handle previous comments
            if (question.previous_comment) {
              setComments(prev => ({
                ...prev,
                [question.question_id]: question.previous_comment
              }));
            }

            // Track previous file responses
          if (question.previous_file_response) {
            setPreviousFileResponses(prev => ({
              ...prev,
              [question.question_id]: question.previous_file_response
            }));
          }

            // Initialize scores with "Not Selected" if no previous score exists
            if (question.previous_user_question_score === undefined) {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: "Not Selected"
              }));
            } else {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: question.previous_user_question_score
              }));
            }

            // If there's a previous score, mark the question as saved
          if (question.previous_user_question_score !== null) {
            setSavedQuestions(prev => ({
              ...prev,
              [question.question_id]: true
            }));
          }
            
          });
        });
      });
    }

  }, [questionsPerDocument]);

  
  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000));
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);

  const toggleDocument = (documentId) => {
    setExpandedDocuments(prev => ({ ...prev, [documentId]: !prev[documentId] }));
  };

  const handleAnswerChange = (questionId, answer, questionType) => {
    setAnswers(prev => {
      if (questionType === 'Multiple Select') {
        const currentAnswers = Array.isArray(prev[questionId]) ? prev[questionId] : [];
        return { ...prev, [questionId]: currentAnswers.includes(answer) ? currentAnswers.filter(item => item !== answer) : [...currentAnswers, answer] };
      } else {
        return { ...prev, [questionId]: answer };
      }
    });
  };

  const closeFullScreenImage = () => {
    setFullScreenImage(null);
  };

  //
  const compressImage = (file, quality = 0.7, maxWidth = 1024, maxHeight = 1024) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      // Calculate new dimensions while maintaining aspect ratio
      let { width, height } = img;
      
      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }
      
      canvas.width = width;
      canvas.height = height;
      
      // Draw and compress
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob(
        (blob) => {
          // Create a new File object with the same name but compressed
          const compressedFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now()
          });
          resolve(compressedFile);
        },
        file.type,
        quality
      );
    };
    
    img.src = URL.createObjectURL(file);
  });
};

  
  

  // Update the handleFileChange function
  const handleFileChange = async (questionId, event) => {
  const file = event.target.files[0];
  if (file && (file.type === 'image/png' || file.type === 'image/jpeg') && file.size <= 10 * 1024 * 1024) {
    try {
      // Compress the image before processing
      const compressedFile = await compressImage(file, 0.7, 1024, 1024);
      
      console.log(`Original size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);
      console.log(`Compressed size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
      
      // Mark any previous file as removed
      setRemovedPreviousFiles(prev => ({
        ...prev,
        [questionId]: true
      }));

      // Update both answers and files state with compressed file
      handleAnswerChange(questionId, compressedFile);
      setFiles(prev => ({ ...prev, [questionId]: compressedFile }));

      // Create a URL for the compressed file and store it in previewPhotos
      if (compressedFile.type.startsWith('image/')) {
        const objectUrl = URL.createObjectURL(compressedFile);
        setPreviewPhotos(prev => ({ ...prev, [questionId]: objectUrl }));
        setPreviewPhoto(objectUrl); // Keep this for backwards compatibility
      }
    } catch (error) {
      console.error('Error compressing image:', error);
      setErrorMessage('Error processing image. Please try again.');
    }
  } else {
    setErrorMessage('Only PNG and JPEG files less than 10MB are allowed.');
  }
};

// Update the handleRemoveFile function
const handleRemoveFile = (questionId) => {
  handleAnswerChange(questionId, '');
  setFiles(prev => {
    const newFiles = { ...prev };
    delete newFiles[questionId];
    return newFiles;
  });
  
  // Release the URL object to avoid memory leaks
  if (previewPhotos[questionId]) {
    URL.revokeObjectURL(previewPhotos[questionId]);
  }
  
  setPreviewPhotos(prev => {
    const newPreviews = { ...prev };
    delete newPreviews[questionId];
    return newPreviews;
  });
  
  setPreviewPhoto(null); // Keep this for backwards compatibility
  document.querySelectorAll('input[type="file"]').forEach(input => input.value = '');
};

  const handleCommentChange = (questionId, comment) => {
    setComments(prev => ({
      ...prev,
      [questionId]: comment
    }));
  };

  const handleScoreChange = (questionId, score) => {
    setQuestionScores(prev => ({
      ...prev,
      [questionId]: score
    }));
  };

  const generateScoreOptions = (maxScore) => {
    const options = [<option key="not-selected" value="Not Selected">Not Selected</option>];
    for (let i = 0; i <= maxScore; i += 5) {
      options.push(<option key={i} value={i.toString()}>{i}</option>);
    }
    options.push(<option key="not-applicable" value="Not Applicable">Not Applicable</option>);
    return options;
  };

  
  const handleSaveIndividualQuestion = async (questionId) => {
    setErrorMessage('');
    setSubmitStatus('loading');

    // Set this specific question as saving

    // Validate score for current question
    const score = questionScores[questionId];

    
    if (!score || score === 'Not Selected') {

      setShowToaster(prev => ({ ...prev, savingError: true }));

      setQuestionErrors(prev => ({ 
        ...prev, 
        [questionId]: 'Please select a score or mark as Not Applicable' 
      }));
      setSubmitStatus('idle');
      return;
    }
  
    let question = null;
    let documentId = null;
    let category = null;
  
    // Find the question and its document
    for (const docId in questionsPerDocument) {
      const documentQuestions = questionsPerDocument[docId];
      for (const cat in documentQuestions) {
        const questionsInCategory = documentQuestions[cat];
        const foundQuestion = questionsInCategory.find(q => q.question_id === questionId);
        if (foundQuestion) {
          question = foundQuestion;
          documentId = docId;
          category = cat;
          break;
        }
      }
      if (question) break;
    }
  
    if (!question) {
      setQuestionErrors(prev => ({ 
        ...prev, 
        [questionId]: 'Error: Question not found in the document' 
      }));
      setSubmitStatus('idle');
      return;
    }

    setSavingQuestions(prev => ({
    ...prev,
    [questionId]: true
  }));
  
  
    try {
      const formData = new FormData();
      const currentDocument = shePackDocuments.find(doc => doc.shepack_document_id === documentId);
  
      if (!currentDocument) throw new Error('Document not found');
  
      // Calculate total score only for questions that have been answered
      let userTotalScore = 0;
      let updatedDocumentScore = 0;
      
      // Get all questions for this document
      const documentQuestions = questionsPerDocument[documentId];
      if (documentQuestions) {
        Object.values(documentQuestions).forEach(categoryQuestions => {
          categoryQuestions.forEach(q => {
            const questionScore = questionScores[q.question_id];
            // Only include in document score if not marked as Not Applicable
            if (questionScore !== 'Not Applicable') {
              updatedDocumentScore += parseInt(q.question_score);
            }
            // Only add to user total if question has been answered
            if (questionScore !== 'Not Applicable' && questionScore !== 'Not Selected') {
              userTotalScore += parseInt(questionScore);
            }
          });
        });
      }
  
      // Append all necessary data to formData
      formData.append('user_company', selectedCompany);
      formData.append('user_department', selectedDepartment);
      formData.append('userId', user.user_id);
      formData.append('userName', user.userName);
      formData.append('userSurname', user.userSurname);
      formData.append('userType', user.userType);
      formData.append('companyId', selectedCompany);
      formData.append('departmentId', selectedDepartment);
      formData.append('shePackDocumentId', documentId);
      formData.append('shePackDocumentName', currentDocument.shepack_document_name);
      formData.append('userTotalScore', userTotalScore.toString());
      formData.append('shepackDocumentscore', currentDocument.shepack_document_score.toString());
      formData.append('updatedShePackDocumentScore', updatedDocumentScore.toString());
      formData.append('questionId', questionId);
      formData.append('questionName', question.question_name);
      formData.append('questionScore', score);
      formData.append('document_question_score', question.question_score);
      
      formData.append('category', category);
      formData.append('questionType', question.question_type);
  
      // Handle different question types
      const answer = answers[questionId];
  
      if (question.question_type === 'Multiple Select') {
        formData.append('answer', Array.isArray(answer) ? answer.join(', ') : answer || '');
      } else {
        formData.append('answer', answer || '');
      }
  
      // Handle file upload separately, similar to comments
      if (question.is_File_required === 'Yes' && files[questionId]) {
        formData.append('response', files[questionId]);
        formData.append('answer', files[questionId].name);
      }
  
      // Add optional fields
      if (comments[questionId]) {
        formData.append('comment', comments[questionId]);
      }
  
      if (expiryDateInput[questionId]) {
        formData.append('expiry_date', expiryDateInput[questionId]);
      }
  
      // Send request to server
      await axios.post(
        '/api/she-pack/consultant/consultant-fill-in/template/save-individual-question', 
        formData, 
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );

      // After successful save, update the savedQuestions state
    setSavedQuestions(prev => ({
      ...prev,
      [questionId]: true
    }));
  
      // Clear errors and show success message
      setQuestionErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[questionId];
        return newErrors;
      });

      if (onScoreUpdate) {
        await onScoreUpdate(documentId);
      }

      setShowToaster(prev => ({ ...prev, questionSaved: true }));
      setSubmitStatus('success');
  
    } catch (error) {

      setSubmitStatus('idle');
      const errorMsg = error.response 
        ? `Server error: ${error.response.data.message}` 
        : error.request 
          ? 'No response from server. Please check your connection.' 
          : `Error: ${error.message}`;
      setQuestionErrors(prev => ({ ...prev, [questionId]: errorMsg }));
      
    } finally {

      // Always remove saving state for this question
      setSavingQuestions(prev => ({
        ...prev,
        [questionId]: false
      }));

    }
  };

  const handleSaveCategory = async (category, documentId) => {

    console.log('Starting category save process...', category);
    console.log('Starting category save process...', category, 'Document ID:', documentId);
    setSubmitStatus('loading');

    
  
    // Get all questions for this category
    const categoryQuestions = questionsPerDocument[documentId][category];
  
    // Validate that all questions have valid scores
    // Validate that all questions have scores other than "Not Selected"
    const invalidScoreQuestions = categoryQuestions.filter(question => {
      const score = questionScores[question.question_id];
      return !score || score === 'Not Selected';
    });
  
    if (invalidScoreQuestions.length > 0) {
      setShowToaster(prev => ({ ...prev, savingError: true }));

      const validationErrors = invalidScoreQuestions.map(question => 
        `Please select a score or mark as Not Applicable for question: ${question.question_name}`
      );
  
      setQuestionCategoryErrors(prev => ({
        ...prev,
        [category]: validationErrors
      }));
      setSubmitStatus('idle');
      return; // Prevent submission if any question has Not Selected
    }

    // Set this specific category as saving
    setSavingCategories(prev => ({
      ...prev,
      [`${documentId}-${category}`]: true
    }));

  
  
    try {
      // Find the document details from shePackDocuments array
      const currentDocument = shePackDocuments.find(doc => doc.shepack_document_id === documentId);
      
      if (!currentDocument) {
        throw new Error('Document not found');
      }
  
      // Calculate updated document score excluding Not Applicable questions
      let updatedDocumentScore = 0;
      let userTotalScore = 0;
      
      if (questionsPerDocument[documentId]) {
        Object.values(questionsPerDocument[documentId]).forEach(categoryQuestions => {
          categoryQuestions.forEach(q => {
            const questionScore = questionScores[q.question_id];
            // Only include in updated document score if not marked as Not Applicable
            if (questionScore !== 'Not Applicable') {
              updatedDocumentScore += parseInt(q.question_score);
            }
            // Calculate user's total score
            if (questionScore !== 'Not Applicable' && questionScore !== 'Not Selected') {
              userTotalScore += parseInt(questionScore);
            }
          });
        });
      }
      
      // Prepare answers array for all questions in the category
      const categoryAnswers = categoryQuestions.map(question => ({
        questionId: question.question_id,
        questionName: question.question_name,
        questionType: question.question_type,
        category: category,
        answer: answers[question.question_id] || '',
        questionScore: questionScores[question.question_id],
        comment: comments[question.question_id],
        expiry_date: expiryDateInput[question.question_id],
        companyId: selectedCompany,
        departmentId: selectedDepartment,
      }));
  
      // Prepare form data
      const formData = new FormData();
      formData.append('answers', JSON.stringify(categoryAnswers));
      
      // Use the document ID from the current document
      formData.append('shePackDocumentId', documentId);
      formData.append('shePackDocumentName', currentDocument.shepack_document_name);
      formData.append('userId', user.user_id);
      formData.append('userName', user.userName);
      formData.append('userSurname', user.userSurname);
      formData.append('userType', user.userType);
      formData.append('companyId', selectedCompany);
      formData.append('departmentId', selectedDepartment);
      
      formData.append('userTotalScore', userTotalScore.toString());
      formData.append('shepackDocumentscore', currentDocument.shepack_document_score || 0);
      formData.append('updatedShePackDocumentScore', updatedDocumentScore.toString());
      formData.append('totalUserScorePercentage', ((userTotalScore / updatedDocumentScore) * 100).toFixed(2));
      
      console.log('Sending form data:', {
        documentId,
        documentName: currentDocument.shepack_document_name,
        category,
        answersCount: categoryAnswers.length,
        updatedDocumentScore
      });
  
      // Append files if any
      categoryQuestions.forEach((question, index) => {
        const questionId = question.question_id;
        
        formData.append(`questions[${index}].questionId`, questionId);
        formData.append(`questions[${index}].questionName`, question.question_name);
        formData.append(`questions[${index}].questionType`, question.question_type);
        formData.append(`questions[${index}].category`, category);
        formData.append(`questions[${index}].questionScore`, questionScores[questionId] || '');
        formData.append(`questions[${index}].document_question_score`, question.question_score);
        
        
        // Handle different question types for answers
        const answer = answers[questionId];
        if (question.question_type === 'Multiple Select') {
          formData.append(`questions[${index}].answer`, Array.isArray(answer) ? answer.join(', ') : answer || '');
        } else {
          formData.append(`questions[${index}].answer`, answer || '');
        }
        
        // Handle file upload for this question
        if (question.is_File_required === 'Yes' && files[questionId]) {
          formData.append(`files[${questionId}]`, files[questionId]);
          formData.append(`questions[${index}].answer`, files[questionId].name);
        }
        
        // Add optional fields
        if (comments[questionId]) {
          formData.append(`questions[${index}].comment`, comments[questionId]);
        }
        
        if (expiryDateInput[questionId]) {
          formData.append(`questions[${index}].expiry_date`, expiryDateInput[questionId]);
        }
      });
  
      const response = await axios.post(
        '/api/she-pack/consultant/consultant-fill-in/template/save-all-questions',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );
  
      console.log('Category save response:', response.data);

       // After successful save, mark all questions in the category as saved
    if (questionsPerDocument[documentId] && questionsPerDocument[documentId][category]) {
      const categoryQuestions = questionsPerDocument[documentId][category];
      const updatedSavedQuestions = { ...savedQuestions };
      
      categoryQuestions.forEach(question => {
        updatedSavedQuestions[question.question_id] = true;
      });
      
      setSavedQuestions(updatedSavedQuestions);
    }
  
      // Clear any existing errors for this category
      setQuestionCategoryErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[category];
        return newErrors;
      });
  
      setQuestionErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[documentId];
        return newErrors;
      });

       // After successful save, call the parent's update function
      if (onScoreUpdate) {
        await onScoreUpdate(documentId);
      }

      setShowToaster(prev => ({ ...prev, categorySaved: true }));
      setSubmitStatus('success');
  
    } catch (error) {
      console.error('Save category error:', error);
      setQuestionCategoryErrors(prev => ({
        ...prev,
        [category]: [`Error saving category: ${error.response?.data?.message || error.message}`]
      }));
      setSubmitStatus('idle');
    } finally {

      setSavingCategories(prev => ({
      ...prev,
      [`${documentId}-${category}`]: false
    }));

    }
  };

  //
  const handleSubmit = async (documentId) => {
    setErrorMessage('');
    setSubmitStatus('loading');
  
    const currentDocument = shePackDocuments.find(doc => doc.shepack_document_id === documentId);
    if (!currentDocument) {
      setErrorMessage('Document not found');
      setSubmitStatus('idle');
      return;
    }
  
    const documentQuestions = questionsPerDocument[documentId];
    if (!documentQuestions) {
      setErrorMessage('No questions found for this document');
      setSubmitStatus('idle');
      return;
    }
  
    // Validate all questions have valid scores
    const invalidScores = [];
    Object.entries(documentQuestions).forEach(([category, questions]) => {
      questions.forEach(question => {
        const score = questionScores[question.question_id];
        if (!score || score === 'Not Selected') {
          invalidScores.push(question.question_name);
        }
      });
    });
  
    if (invalidScores.length > 0) {
      setShowToaster(prev => ({ ...prev, savingError: true }));
      setSubmitStatus('error');
      setErrorMessage(`Please select a score or mark as Not Applicable for all questions `);
      return; // Prevent submission if any question has Not Selected
    }
  
    try {
      // Calculate updated document score excluding Not Applicable questions
      let updatedDocumentScore = 0;
      let userTotalScore = 0;
  
      if (!currentDocument) throw new Error('Document not found');
      if (!documentQuestions) throw new Error('No questions found for this document');
      
      const unansweredMandatoryQuestions = [];
  
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach(q => {
          const questionScore = questionScores[q.question_id];
          // Only include in updated document score if not marked as Not Applicable
          if (questionScore !== 'Not Applicable') {
            updatedDocumentScore += parseInt(q.question_score);
          }
          // Calculate user's total score
          if (questionScore !== 'Not Applicable' && questionScore !== 'Not Selected') {
            userTotalScore += parseInt(questionScore);
          }
        });
      });
  
      if (unansweredMandatoryQuestions.length > 0) {
        setSubmitStatus('error');
        setErrorMessage(`Please answer all mandatory questions: ${unansweredMandatoryQuestions.join(', ')}`);
        return;
      }
      
      const formData = new FormData();
      formData.append('shePackDocumentId', documentId);
      formData.append('shePackDocumentName', currentDocument.shepack_document_name);
      formData.append('userId', user.user_id);
      formData.append('userName', user.userName);
      formData.append('userSurname', user.userSurname);
      formData.append('userType', user.userType);
      formData.append('companyId', selectedCompany);
      formData.append('departmentId', selectedDepartment);
  
      // Use calculated values instead of stored values
      formData.append('userTotalScore', userTotalScore.toString());
      formData.append('shepackDocumentscore', currentDocument.shepack_document_score || 0);
      formData.append('updatedShePackDocumentScore', updatedDocumentScore.toString());
      formData.append('totalUserScorePercentage', ((userTotalScore / updatedDocumentScore) * 100).toFixed(2));
  
      // Process each question individually and append to formData
      let questionIndex = 0;
      
      // Track which files will be included in the request
      const includedFiles = new Set();
      
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach((question) => {
          const questionId = question.question_id;
          
          formData.append(`questions[${questionIndex}].questionId`, questionId);
          formData.append(`questions[${questionIndex}].questionName`, question.question_name);
          formData.append(`questions[${questionIndex}].questionType`, question.question_type);
          formData.append(`questions[${questionIndex}].category`, category);
          formData.append(`questions[${questionIndex}].questionScore`, questionScores[questionId] || '');
          
          // Handle different question types for answers
          const answer = answers[questionId];
          if (question.question_type === 'Multiple Select') {
            formData.append(`questions[${questionIndex}].answer`, Array.isArray(answer) ? answer.join(', ') : answer || '');
          } else {
            // For regular answers, preserve existing answer if no new input
            formData.append(`questions[${questionIndex}].answer`, answer || '');
          }
          
          // For file questions - only include the file if a new one was selected
          // Don't override existing file answer if no new file is selected
          if (question.is_File_required === 'Yes') {
            if (files[questionId]) {
              // If we have a new file, include it in the form data
              formData.append(`files[${questionId}]`, files[questionId]);
              formData.append(`questions[${questionIndex}].answer`, files[questionId].name);
              // Track that we're including this file
              includedFiles.add(questionId);
            } else {
              // If no new file is selected, DON'T set answer to empty string
              // We'll let the server use the existing file from the database
              // Only need to explicitly set answer to empty if there's no existing file
              
              // Important: Don't override the answer field if no new file is selected
              // The backend will keep the existing file if no new file is provided
            }
          }
          
          // Add optional fields
          if (comments[questionId]) {
            formData.append(`questions[${questionIndex}].comment`, comments[questionId]);
          }
          
          if (expiryDateInput[questionId]) {
            formData.append(`questions[${questionIndex}].expiry_date`, expiryDateInput[questionId]);
          }
          
          // Add a special flag for file questions that don't have a new file
          // This helps the backend know whether to keep existing files or not
          if (question.is_File_required === 'Yes' && !includedFiles.has(questionId)) {
            formData.append(`questions[${questionIndex}].keepExistingFile`, 'true');
          }
          
          questionIndex++;
        });
      });
  
      // Also append the JSON string of all answers for backward compatibility
      // but respect the file preservation logic
      const allAnswers = [];
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach(question => {
          const questionId = question.question_id;
          const answer = answers[questionId];
          const answerData = {
            questionId: questionId,
            questionName: question.question_name,
            questionType: question.question_type,
            category: category,
            answer: '',
            questionScore: questionScores[questionId],
            comment: comments[questionId] || '',
            expiry_date: expiryDateInput[questionId] || '',
            companyId: selectedCompany,
            departmentId: selectedDepartment,
          };
  
          if (question.question_type === 'Multiple Select') {
            answerData.answer = Array.isArray(answer) ? answer.join(', ') : answer || '';
          } else {
            answerData.answer = answer || '';
          }
  
          // Update answer with file name only if a new file was selected
          if (question.is_File_required === 'Yes' && files[questionId]) {
            answerData.answer = files[questionId].name;
          } else if (question.is_File_required === 'Yes') {
            // If no new file is selected, indicate that we should keep existing file
            answerData.keepExistingFile = true;
          }
  
          allAnswers.push(answerData);
        });
      });
      formData.append('answers', JSON.stringify(allAnswers));
  
      console.log('Submitting form data:', {
        documentId,
        documentName: currentDocument.shepack_document_name,
        answersCount: allAnswers.length,
        updatedDocumentScore
      });
  
      await axios.post('/api/she-pack/consultant/consultant-fill-in/template/submit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      setSubmitStatus('success');
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        navigate('/she-pack/she-pack-management');
      }, 2000);
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitStatus('idle');
      const errorMsg = error.response?.data?.message 
        ? `Server error: ${error.response.data.message}`
        : error.request 
          ? 'No response from server. Please check your connection.'
          : `Error: ${error.message}`;
      setErrorMessage(errorMsg);
    }
  };

  /* ----------------- Previous File Resposne ------------- */

  const handleRemovePreviousFile = (questionId) => {
    setRemovedPreviousFiles(prev => ({
      ...prev,
      [questionId]: true
    }));
    
    // Also clear any new files that might have been uploaded
    handleRemoveFile(questionId);
  };

  
  

  const bufferToBase64 = (buffer) => {
    if (buffer && buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
      const binaryString = buffer.data.map(byte => String.fromCharCode(byte)).join('');
      return btoa(binaryString);
    }
    return null;
  };

  // This function to render previous file response
  const renderPreviousFileResponse = (question, index) => {
    if (removedPreviousFiles[question.question_id] || files[question.question_id]) {
      return null;
    }
    
    const fileResponse = question.previous_file_response;
    const base64String = bufferToBase64(fileResponse);
    if (!base64String) {
      return <p>Invalid image data</p>;
    }
  
    const base64ToBinary = atob(base64String);
    const mimeType = 'image/png'; // Assuming the mimeType is 'image/png'
    const dataUrl = `data:${mimeType};base64,${base64ToBinary}`;
  
    return (
      <div>
        <div>
          <h4>Previous File Submission  </h4>
        </div>
  
        <div className='checklist-question-toaster-image-delete-button-container'>
          <CiImageOn 
            className='checklist-question-toaster-image-icon' 
            onClick={() => setFullScreenImage(dataUrl)} 
          />
          
          <button 
            type='button' 
            className='delete-image-button' 
            onClick={() => handleRemovePreviousFile(question.question_id)}
          > 
            <MdDeleteOutline /> 
          </button>
        </div>
        {expandedImageIndex === index && (
          <div className="expanded-image-overlay" onClick={() => setExpandedImageIndex(null)}>
            <p>{question.previous_response}</p>
            <img
              className='view-checklist-view-image'
              src={dataUrl}
              alt='view'
              style={{ maxWidth: '200px', maxHeight: '200px' }} 
            />
          </div>
        )}
      </div>
    );
  };


  

  if (!isOpen) return null;

  return (

    <div className="checklist-question-user-fill-in-checklist-main-container">
        
        <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="consultant-fill-in-template-main-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button"> Back</button>
            </div>
          </div>
          
          <div className="consultant-Template-fill-in-header-main-container">
            <div className="Template-fill-in-header-text-and-search-main-container">

              <div className="Template-fill-in-header-text-main-container">
                <h2> Legal Compliance - <span className="secondary-color-paragraph">Consultant Fill In</span></h2>
                
                <p>You are completing a she file for company <span className='secondary-color-text'>{selectedCompanyName}</span> and site <span className='secondary-color-text'>{selectedDepartmentName}</span></p>
              
                
              </div>

              <div>

                <div className='consultant-fill-in-she-file-score-display-main-main-container'>
                    <h4>SHE File :<span className='secondary-color-paragraph'> {selectedShePackName}</span></h4>

                    <div className='consultant-fill-in-she-file-score-display-main-container'>

                      <div>
                        <p><span className='secondary-color-paragraph'>Score</span></p>
                      </div>
                      <div>
                        {totalUserScore} / {shePackScore}
                      </div>
                    </div>

                    <div>
                      <p><span className='secondary-color-paragraph'>Percentage : {totalUserPercentage || 0} %</span></p>
                    </div>
                  </div>
                  
              </div>

             
              
            </div>
            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <div className='compliance-tracker-consultant-fill-in-table-main-container'>

                <div className="compliance-tracker-consultant-fill-in-table-container">

                  <table className='compliance-tracker-consultant-fill-in-table'>
                    
                    <colgroup>
              
                      <col style={{width: "50px"}}/>{/* view */}
                      <col style={{width: "350px"}}/>{/* template name */}
                      <col style={{width: "150px"}}/>{/* Template score */}
                      <col style={{width: "100px"}}/>{/* Template % */}
                      <col style={{width: "150px"}}/>{/* Submission Status */}
                      <col style={{width: "150px"}}/>{/* QA Status */}
                      <col style={{width: "300px"}}/>{/* QA Status Comment */}
                      
                      
                    </colgroup>
                    
                    <thead>
                      <tr>
                        <th>View</th>
                        <th>Template Name</th>
                        <th>Template Score</th>
                        <th>Template %</th>
                        <th>Submission Status</th>
                        <th>QA Status</th>
                        <th>QA Status Comment</th>
                      </tr>
                    </thead>

                  
                  
                  <tbody>

                    {shePackDocuments.length === 0 ? (
                      <tr >
                        <td>
                          <i>No documents found for this SHE Pack.</i>
                        </td>
                      </tr>
                    ) : (
                      shePackDocuments.map((document, index) => (
                        <>

                        <tr  key={index}>
                          <td >
                              <FaClipboardList 
                                className='view-checklist-submition-icon' 
                                onClick={() => {
                                  
                                  if ((document.qa_status === 'Rejected' && document.submission_status === 'Completed') || 
                                      document.submission_status !== 'Completed') {
                                    toggleDocument(document.shepack_document_id);
                                  }
                                }}
                                style={{
                                  cursor: (document.qa_status === 'Rejected' && document.submission_status === 'Completed') || 
                                        document.submission_status !== 'Completed' ? 'pointer' : 'not-allowed',
                                  opacity: (document.qa_status === 'Rejected' && document.submission_status === 'Completed') || 
                                          document.submission_status !== 'Completed' ? 1 : 0.5
                                }}
                              />
                            </td>


                            <td>{document.shepack_document_name}</td>
                            <td>  {document.user_score} / {document.effective_document_score || document.shepack_document_score}</td>
                            <td>{document.user_percentage } %</td>
                            <td>{document.submission_status || 'No submission'}</td>
                            <td>{document.qa_status }</td>
                            <td>{document.qa_status_comment }</td>

                        </tr>
                        
                          {expandedDocuments[document.shepack_document_id] && (
                            

                            <tr>

                              
                              <td colSpan="7">

                                <div className='consultant-template-questions-fill-in-main-container'>

                                  {/* Search Questions */}
                                  <div className='search-questions-main-container'>

                                    <div className='consultant-fill-in-search-icon-container'>
                                      <CiSearch className='consultant-fill-in-search-icon'/>
                                    </div>
                                    <input
                                      className='consultant-template-input-field'
                                      type="text"
                                      placeholder="Search questions by name or reference."
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <button 
                                      className='confirm-button'
                                      onClick={() => setSearchTerm('')}
                                    >
                                      Clear Search
                                    </button>
                                  </div>

                              {filteredQuestionsPerDocument[document.shepack_document_id] && 
                      Object.entries(filteredQuestionsPerDocument[document.shepack_document_id]).map(([category, categoryQuestions]) => (

                                                      <>  
                                                        <div className='consultant-template-questions-fill-in-container' key={category}>
                                                        <div className='checklist-question-toaster-user-fill-in-checklist-element-category-save-container'>
                                                          {/*

                                                          <h2>
                                                            {category === " " && (

                                                                <div>
                                                                    Category - <span className='secondary-color-paragraph'>{category}</span>
                                                                </div>

                                                              )}
                                                          </h2>
                                                          
                                                          */}
                                                          

                                                         
                                      <div 
  className={`save-questions-category-category-button-container ${savingCategories[`${document.shepack_document_id}-${category}`] ? 'saving-disabled' : ''}`}
  onClick={() => {
    if (!savingCategories[`${document.shepack_document_id}-${category}`]) {
      handleSaveCategory(category, document.shepack_document_id);
    }
  }}
  style={{
    cursor: savingCategories[`${document.shepack_document_id}-${category}`] ? 'not-allowed' : 'pointer',
    opacity: savingCategories[`${document.shepack_document_id}-${category}`] ? 0.5 : 1
  }}
>
  <div>
    {savingCategories[`${document.shepack_document_id}-${category}`] ? 'Saving...' : 'Save All Questions'}
  </div>
  <div>
    {savingCategories[`${document.shepack_document_id}-${category}`] ? (
      <FaSpinner className="fa-spin" />
    ) : (
      <FaRegSave className='checklist-fillin-button-question-name-and-save-icon-rendering-save-category-icon' />
    )}
  </div>
</div>
{questionCategoryErrors[category] && (
                                      <div className='error-text'>
                                        <ul>
                                          {questionCategoryErrors[category].map((error, index) => (
                                            <li key={index} className='category-error-item'>{error}</li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                    </div>

                                    {/* Table Questions */}
                                    <div className='compliance-tracker-consultant-fill-in-table-main-container'>
                                      <div className="compliance-tracker-consultant-fill-in-table-container">
                                        <table className='compliance-tracker-consultant-fill-in-table'>
                                          <colgroup>
                                            <col style={{width: "50px"}}/>{/* number */}
                                            <col style={{width: "50px"}}/>{/* view */}
                                            <col style={{width: "100px"}}/>{/* template name */}
                                            <col style={{width: "150px"}}/>{/* Template score */}
                                            <col style={{width: "300px"}}/>{/* Template % */}
                                            <col style={{width: "150px"}}/>{/* Submission Status */}
                                            <col style={{width: "200px"}}/>{/* QA Status */}
                                            <col style={{width: "300px"}}/>{/* QA Status */}
                                            <col style={{width: "300px"}}/>{/* QA Status */}
                                            <col style={{width: "300px"}}/>{/* QA Comment */}


                                          </colgroup>

                                          <thead>
                                              <tr>
                                                <th>#</th>
                                                <th>Save</th>
                                                <th>Status</th>
                                                <th>Reference</th>
                                                <th>Question</th>
                                                <th>Score</th>
                                                <th>Comment</th>
                                                <th>File Upload</th>
                                                <th>File</th>
                                                <th>QA Comment</th>
                                              </tr>
                                          </thead>

                                          <tbody>

                                            {categoryQuestions.map((question, index) => (
                                              <>
                                                <tr key={index}>

                                                  <td>
                                                    <span className='secondary-color-paragraph'>{index + 1}</span>
                                                  </td>
                                                
                                                {/* Column Save Icon */}
                                                <td>

                                                  <div>
                                                    <FaRegSave 
                                                      className={`view-checklist-submition-icon ${savingQuestions[question.question_id] ? 'saving-disabled' : ''}`}
                                                      onClick={() => {
                                                        if (!savingQuestions[question.question_id]) {
                                                          handleSaveIndividualQuestion(question.question_id);
                                                        }
                                                      }}
                                                      style={{
                                                        cursor: savingQuestions[question.question_id] ? 'not-allowed' : 'pointer',
                                                        opacity: savingQuestions[question.question_id] ? 0.5 : 1
                                                      }}
                                                    />
                                                    {savingQuestions[question.question_id] && (
                                                      <FaSpinner className="fa-spin saving-spinner" />
                                                    )}
                                                  </div>

                                                </td>

                                                {/* Column Status */}
                                                <td>

                                                  <div>
                                                          
                                                    <p> {savedQuestions[question.question_id] ? 
                                                      <span className="saved-status"><IoIosCloudDone />Saved</span> : 
                                                      <span className="not-saved-status"><MdCancel />Not Saved Yet</span>}
                                                    </p>

                                                  </div>

                                                </td>

                                                {/* Reference */}
                                                <td>
                                                  <div>
                                                      <p> {question.question_reference} </p>
                                                    </div>
                                                </td>

                                                {/* Question */}
                                                <td 
                                                  style={{
                                                    maxWidth: "300px",
                                                    wordWrap: "break-word",
                                                    whiteSpace: "normal"
                                                  }}
                                                >

                                                  <div>
                                                    <p>{question.question_name}</p>
                                                  </div>

                                                </td>

                                                {/* Score */}
                                                <td>
                                                  <div className='she-pack-fill-in-question-score-container'>
                                                    
                                                    <div>
                                                      <select
                                                        value={questionScores[question.question_id] || 'Not Selected'}
                                                        onChange={(e) => handleScoreChange(question.question_id, e.target.value)}
                                                        className={questionErrors[question.question_id] ? 'error-border' : ''}
                                                      >
                                                        {generateScoreOptions(parseInt(question.question_score))}
                                                      </select>
                                                      </div>
                                                      <div>
                                                        <p>/{question.question_score}</p>
                                                      </div>
                                                  </div>
                                                </td>

                                                {/* Column - comment */}
                                                <td
                                                  style={{
                                                    maxWidth: "300px",
                                                    wordWrap: "break-word",
                                                    whiteSpace: "normal"
                                                  }}>
                                                

                                                  {question.comment === 'Yes' && (
                                                              <div>
                                                                
                                                                <div>
                                                                  <textarea
                                                                    placeholder='Type your additional comments here '
                                                                    rows={2}
                                                                    cols={30}
                                                                    maxLength={200}
                                                                    value={comments[question.question_id] || ''}
                                                                    onChange={(e) => handleCommentChange(question.question_id, e.target.value)}
                                                                  />
                                                                </div>
                                                                <div>
                                                                  <p><i>Maximum characters allowed 1000.</i></p>
                                                                </div>
                                                              </div>
                                                            )}

                                                </td>

                                                {/* Column - File Upload */}
                                                <td>

                                                  {question.is_File_required === 'Yes' && (
                                                            <div >
                                                             
                                                              <div className='consultant-secondary-color-paragraph'>
                                                                <p className='secondary-color-paragraph'>Please upload an image. Only PNG or JPEG formats <br/> are accepted, and the file size must not exceed 10MB.</p>
                                                              </div>
                                                              
                                                              <input
                                                                className='file-upload-input'
                                                                type="file"
                                                                accept=".png,.jpg,.jpeg"
                                                                onChange={(e) => handleFileChange(question.question_id, e)}
                                                              />

                                                              {/* Fullscreen Preview */}
                                                              {fullScreenImage && (
                                                                <div 
                                                                  className="full-screen-image-overlay" 
                                                                  onClick={closeFullScreenImage}
                                                                >
                                                                  <div className="full-screen-image-container">
                                                                    <img 
                                                                      src={fullScreenImage} 
                                                                      alt="Full Screen Preview" 
                                                                      className="full-screen-image"
                                                                      onClick={(e) => e.stopPropagation()} 
                                                                    />
                                                                    <button 
                                                                      className="close-image-modal-btn" 
                                                                      onClick={closeFullScreenImage}
                                                                    >
                                                                      &times;
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              )}

                                                              
                                                              
                                                            </div>
                                                          )}

                                                
                                                </td>

                                                {/*  */}
                                                <td>

                                                  {answers[question.question_id] && (
                                                      <div>
                                                        {answers[question.question_id] instanceof File &&
                                                          answers[question.question_id].type.startsWith('image/') ? (
                                                            <div className='checklist-question-toaster-image-delete-button-container'>
                                                                        
                                                              <CiImageOn 
                                                                className='checklist-question-toaster-image-icon' 
                                                                onClick={() => setFullScreenImage(previewPhotos[question.question_id])} 
                                                              />

                                                              <button 
                                                                type='button' 
                                                                className='delete-image-button' 
                                                                onClick={() => handleRemoveFile(question.question_id)}
                                                              > 
                                                                <MdDeleteOutline /> 
                                                              </button>
                                                            </div>
                                                          ) : 'No File Uploaded'}
                                                      </div>
                                                    )}

                                                    {/* Show previous file only if no new file and not removed */}
                                                    {question.previous_file_response && !files[question.question_id] && !removedPreviousFiles[question.question_id] 
                                                      ? renderPreviousFileResponse(question, index) : 'No Previous File Uploaded'
                                                    }

                                                </td>

                                                {/*Column -  QA Comment*/}
                                                <td>

                                                  <i>{question.previous_qa_comment|| 'Not Comment'}</i>
                                                </td>
                                                
                                                
                                              </tr>

                                              {/* Table Row - Errors */}
                                              <tr>
                                                <td colSpan='7'>
                                                  <div>
                                                
                                                  {questionErrors[question.question_id] && (
                                                    <div className='error-text'>
                                                      <p>{questionErrors[question.question_id]}</p>
                                                    </div>
                                                  )}
                                                
                                                </div>

                                                </td>
                                              </tr>
                                              </>
                                            ))}

                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    
                                    

                                    
                                  </div>

                              
                                  
                                  
                                  </>

                                  
                                ))}
                              
                            </div>

                            <div style={{ textAlign: 'center' }}>
                                {errorMessage && (
                                  <div className='error-text'>
                                    <p>{errorMessage}</p>
                                  </div>
                                )}
                                {searchTerm && Object.keys(filteredQuestionsPerDocument[document.shepack_document_id] || {}).length === 0 && (
                                  <div className="no-search-results">
                                    <p>No questions found matching "{searchTerm}"</p>
                                  </div>
                                )}
                                <p>By Clicking Submit you agree that the information provided for <span className='secondary-color-paragraph'>{document.shepack_document_name}</span> document , is true.</p>
                                <div className='checklist-question-toaster-button-cancel-container'>
                                  <button 
                                    onClick={() => handleSubmit(document.shepack_document_id)}
                                    className="confirm-button" disabled={submitStatus === 'loading'}>
                                    {submitStatus === 'loading' ? (
                                      <>
                                        <FaSpinner className="fa-spin" />
                                        <span className="submitting-questions-text"> Submitting questions...</span>
                                      </>
                                    ) : (
                                      'Submit'
                                    )}
                                  </button>
                                  <button type='button' className='cancel-button'> Clear</button>
                                </div>
                              </div>
                                
                              </td>
                              
                            
                            </tr>
                          )}
                              
                        </>
                      ))
                    )}

                  </tbody>
                  </table>

                  
                    
                  
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showToaster.questionSaved && <ItemAddedToaster item={'Question Saved'} />}
      {showToaster.categorySaved && <ItemAddedToaster item={'Category Saved'} />}

      {showToaster.savingError && <ItemRemovedToaster item={'Error'} />}

      {showSuccess && 
        
        <CreatedSuccesFullyToaster
          heading='SHE File Submitted Successfully'
        />
      }

        
    </div>
  );
};

export default ToasterConsultantFill;